module.exports = __webpack_public_path__ + "static/media/river4.8a79f060.png";